import currency from "currency.js";

const USD = (value: number) => currency(value, { symbol: "$", precision: 0 });

type Props = Readonly<{
  value: number;
}>;

export function FormattedNumber({ value }: Props): JSX.Element {
  return <>{USD(value).format()}</>;
}
